// extracted by mini-css-extract-plugin
module.exports = {"footer__copyright":"styles_footer__copyright__2jKCH","footer":"styles_footer__23pO3","footer__copyright-year":"styles_footer__copyright-year__1UTUa"};